<section class="main-section p-3 h-100">
    <div class="header-section d-flex align-items-center justify-content-between">
        List Products <mat-icon (click)="closeDialog()" class="cursor-pointer">close</mat-icon>
    </div>
    <div class="main_body position-relative">
        <ng-container *ngIf="selectedTab === 'Selection'">
            <div class="search-section d-flex align-items-center gap-3">
                <mat-icon>search</mat-icon>
                <input [(ngModel)]="searchProducts" class="search-box" (ngModelChange)="searchListProducts()">
            </div>
            <div class="list-products-section">
                <ng-container *ngFor="let item of listProducts">
                    <div class="product-row">
                        <input type="checkbox" class="product-checkbox" (click)="selectProduct(item)"
                            [checked]="item.isSelected" />
                        <img [src]="item.itemImages[0].imgUrl" alt="ZOTAC GAMING GeForce RTX 5070 Ti"
                            class="product-image" />
                        <p class="product-title">
                            {{item.name ? item.name : 'N/A'}}
                        </p>
                    </div>
                </ng-container>
            </div>
            <button class="next-button position-absolute d-flex align-items-center" (click)="selectedTab = 'overView'"
                [disabled]="selectedProducts.length === 0">
                Next <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="selectedTab === 'overView'">
            <div class="list-products-section  h-100 py-3">
                <ng-container *ngFor="let product of selectedProducts">
                    <div class="selected-product-row mb-3">
                        <div class="d-flex gap-3">
                            <img [src]="product.itemImages[0].imgUrl" alt="ZOTAC GAMING GeForce RTX 5070 Ti"
                                class="product-image" />
                            <p class="product-title">
                                {{product.name ? product.name : 'N/A'}}
                            </p>
                        </div>
                        <div class="d-flex align-items-center gap-3 w-100">
                            <span class="white-space-nowrap">RedirectionUrl :</span><input type="text"
                                class="redirection-url" [(ngModel)]="product.redirectionUrl">
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="action-btns w-100 d-flex align-items-center justify-content-between position-absolute">
                <button class="back-btn cursor-pointer" (click)="selectedTab = 'Selection'">Back</button>
                <button class="done-btn cursor-pointer" (click)="addProducts()">Done</button>
            </div>
        </ng-container>
    </div>
</section>